import axios from 'modules/api-client/request';

import { IUserWaitlist, ICreateUserWaitlist, IUserWaitlistResponse } from './types';
import { handleAmazonMessage } from 'modules/api-client/response';

export const getUserWaitlist = () => {
  return axios.get<void, IUserWaitlistResponse[]>('/user/waitlist');
};

export const updateUserWaitlist = (data: IUserWaitlist): Promise<IUserWaitlist> => {
  return axios.post<IUserWaitlist, IUserWaitlist>('/user/waitlist', data).catch(handleAmazonMessage);
};

export const createUserWaitlist = (data: ICreateUserWaitlist): Promise<IUserWaitlist> => {
  return axios.post<ICreateUserWaitlist, IUserWaitlist>('/user/waitlist', data).catch(handleAmazonMessage);
};

